import React, {FC} from 'react';
import EnvironmentContext, {EnvironmentVariables} from './EnvironmentContext';

const EnvironmentProvider: FC<{environmentVars: EnvironmentVariables}> = ({
  environmentVars,
  children,
}) => <EnvironmentContext.Provider value={environmentVars}>{children}</EnvironmentContext.Provider>;

export default EnvironmentProvider;
